import React from 'react';
const ProgressBar = (props) => {
  return (
    <div className='progress-container'>
      {props.points.map(function (item, i) {
        return (
          <div key={i} className='progress-layer' style={{ width: `${item}%`, zIndex: `${i}%` }}></div>
        );
      })}

      <div className='progress-filler' style={{ width: `${props.percent}%` }}></div>
    </div>
  );
};
export default ProgressBar;
